export default __webpack_public_path__ + "static/media/ZoneTypeD.2e7724e5.png";